import $ from 'jquery'
export default {
    name: 'manage-chirurgie',
    components: {},
    props: {
        modal_title: String,
        chirurgie_to_edit: Object,
        modal_toggler: Boolean
    },
    data() {
        return {
            chirurgie: {
                chirurgie_id: 0,
                libelle: '',
                lettre_cle: '',
                kchirurgies: []
            },

            k_chirurgie: {
                kchirurgie_id: 0,
                libelle: ''
            },

            is_exist: false,
            kchirurgie_is_exist: false,

            all_checked: false,
            one_is_checked: [],
            // one_is_checked: [
            //     {
            //         k_chirurgie: '',
            //         k_coef: '',
            //         k_id: '',
            //         pu: ''
            //     }
            // ],
            text_grey: [],

            save_loading: false,
            is_chirurgie: true,
            is_error: false,
            k_chirurgie_is_empty: false
        }
    },

    watch: {
        modal_toggler() {
            this.chirurgie = {
                chirurgie_id: 0,
                libelle: '',
                lettre_cle: '',
                kchirurgies: []
            }
            this.one_is_checked = []
        },

        chirurgie_to_edit() {
            this.setSelectectedKChirurgie()
        },

        one_is_checked() {
            this.k_chirurgie_is_empty = false
        }
    },

    computed: {
        liste_type_mix_datas() {
            return this.$store.getters["liste_type_mix_datas"];
        },
    },

    mounted() {
        this.getListKChirurgie()
    },

    methods: {
        /**
         * List of K Chirurgie
         * @returns 
         */
        getListKChirurgie() {
            this.$store.dispatch("getListeTypeMixData", 'k_chirurgie')
        },

        setSelectectedKChirurgie() {
            this.one_is_checked = []

            this.chirurgie_to_edit.kchirurgies.forEach((el) => {
                // let k = {
                //     k_chirurgie: el.k_chirurgie,
                //     k_coef: el.k_coef,
                //     k_id: el.k_id,
                //     pu: parseInt(el.pu)
                // }
                this.one_is_checked.push(el.k_id)
            });

            this.chirurgie = {
                chirurgie_id: this.chirurgie_to_edit.chirurgie_id,
                libelle: this.chirurgie_to_edit.chirurgie,
                lettre_cle: this.chirurgie_to_edit.lettre_cle,
                kchirurgies: this.chirurgie_to_edit.kchirurgies
            }
        },

        async submit() {
            const isValid = await this.$refs.chirurgie_form.validate();

            if (!isValid) {
                return;
            }


            /** Elimine les K déselectionnées */
            let nk = []
            this.one_is_checked.forEach(skchirurg => {
                var n_kchirurgie = this.chirurgie.kchirurgies.filter((el) => {
                    return el.k_id == skchirurg
                })
                nk.push(...n_kchirurgie)
            });

            /** Rajoute les nouvelles K choisi */
            let nk_choisi = []
            this.one_is_checked.forEach(chkd => {
                var is_found = nk.some(el => {
                    return el.k_id == chkd
                })

                if (!is_found) {
                    let k = {
                        k_chirurgie: '',
                        k_coef: '',
                        k_id: chkd,
                        pu: 0
                    }
                    nk_choisi.push(k)
                }
            });

            // Join final selected k chirurgie
            nk.push(...nk_choisi)

            let data = {
                chirurgie_id: this.chirurgie.chirurgie_id,
                chirurgie: this.chirurgie.libelle,
                lettre_cle: this.chirurgie.lettre_cle,
                k_chirurgie: nk
            }

            if (nk.length == 0) {
                this.k_chirurgie_is_empty = true
                return
            }
            this.save_loading = true

            this.$store.dispatch("saveChirurgie", data).then((response) => {
                this.save_loading = false

                if (response > 0) {
                    this.$refs.chirurgie_form.reset()
                    this.$refs.modal_chirurgie.click()

                    this.$emit('emitChirurgie')

                    this.one_is_checked = []
                    document.getElementById("kc-tous").checked = false;
                    this.chirurgie = {
                        chirurgie_id: 0,
                        libelle: '',
                        lettre_cle: ''
                    }
                } else {
                    this.is_exist = true
                }
            })
        },

        toutSelectionner() {
            let is_checked = $('#kc-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                let i = 0
                this.liste_type_mix_datas.forEach((data) => {
                    this.text_grey[i] = 'text-grey'
                    this.one_is_checked.push(data.champ_id)
                    i++
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false

                let i = 0
                this.liste_type_mix_datas.forEach(() => {
                    this.text_grey[i] = ''
                    i++
                });
            }
        },

        onOneChange(index) {
            let is_checked = $('#kc'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c
            document.getElementById("kc-tous").checked = false;
        },

        clearError() {
            this.is_exist = false
            this.kchirurgie_is_exist = false
        },
        
        toggleKchirurgie(v) {
            if (v == 1) {   // Add new K Chirurgie
                this.is_chirurgie = false
            } else {        // Add Chirurgie
                this.is_chirurgie = true
            }
        },

        async submitKChirurgie() {
            const isValid = await this.$refs.kchirurgie_form.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true

            this.$store.dispatch("saveKChirurgie", this.k_chirurgie).then((response) => {
                this.save_loading = false

                if (response > 0) {
                    this.getListKChirurgie()
                    this.$refs.kchirurgie_form.reset()
                    this.is_chirurgie = true

                    this.k_chirurgie = {
                        kchirurgie_id: 0,
                        libelle: '',
                    }
                } else {
                    this.kchirurgie_is_exist = true
                }
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        },
    }
}


